// extracted by mini-css-extract-plugin
export default {"Tab-Content":"main_Tab-Content__0mm26"};